import { render, staticRenderFns } from "./AIGeneratedTextAreaElement.vue?vue&type=template&id=e521701c&scoped=true&"
import script from "./AIGeneratedTextAreaElement.vue?vue&type=script&lang=ts&"
export * from "./AIGeneratedTextAreaElement.vue?vue&type=script&lang=ts&"
import style0 from "./AIGeneratedTextAreaElement.vue?vue&type=style&index=0&id=e521701c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e521701c",
  null
  
)

export default component.exports